import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Fade, Slide, Zoom } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import Icon from '../Icon';
import classes from './BackgroundSlideshow.scss';
import BackgroundSlideshowImage from './BackgroundSlideshowImage';

const buttonStyle = {
  background: 'none',
  border: 'none',
  fontSize: '24px',
  color: '#fff',
  padding: '10px',
  textShadow: '0 1px 2px rgba(0,0,0,.6)',
};

const prevArrow = (
  <button style={buttonStyle} type="button">
    <Icon icon="back-arrow" />
  </button>
);
const nextArrow = (
  <button style={buttonStyle} type="button">
    <Icon icon="select-arrow" />
  </button>
);

const BackgroundSlideshow = ({ images, slideshowSetting }) => {
  const slideshowRef = useRef(null);
  const [leftSlideIntervalId, setLeftSlideIntervalId] = useState(null);
  const slideDuration = slideshowSetting?.slideDuration
    ? Number(slideshowSetting?.slideDuration)
    : 0;
  const transitionSpeed = slideshowSetting?.transitionSpeed
    ? Number(slideshowSetting?.transitionSpeed)
    : 0;
  const transitionTypeValue = slideshowSetting?.transitionType?.value;

  const startLeftSlide = () => {
    const intervalId = setInterval(() => {
      slideshowRef.current.goBack();
    }, slideDuration * 1000 + transitionSpeed);
    return intervalId;
  };

  const stopLeftSlide = () => {
    clearInterval(leftSlideIntervalId);
    setLeftSlideIntervalId(null);
  };

  useEffect(() => {
    if (
      transitionTypeValue === 'slide' &&
      slideshowSetting?.transitionDirection?.value === 'ltor' &&
      images.length > 1
    ) {
      const intervalId = startLeftSlide();
      setLeftSlideIntervalId(intervalId);
    }
    return () => {
      if (leftSlideIntervalId) {
        stopLeftSlide();
      }
    };
  }, [
    transitionTypeValue,
    slideshowSetting?.transitionDirection?.value,
  ]);

  let SlideshowWrapper = Fade;
  let scale = 1;

  if (transitionTypeValue === 'slide') {
    SlideshowWrapper = Slide;
  } else if (transitionTypeValue === 'zoomin') {
    SlideshowWrapper = Zoom;
    scale = 1.4;
  } else if (transitionTypeValue === 'zoomout') {
    SlideshowWrapper = Zoom;
    scale = 0.7;
  }
  if (images.length === 1) {
    return (
      <BackgroundSlideshowImage
        image={images[0]}
      />
    );
  }
  return (
    <SlideshowWrapper
      ref={slideshowRef}
      duration={slideDuration * 1000}
      transitionDuration={transitionSpeed}
      arrows={
        !!(
          slideshowSetting?.enableControls &&
          transitionTypeValue === 'slide'
        )
      }
      indicators={false}
      prevArrow={prevArrow}
      nextArrow={nextArrow}
      scale={scale}
      className={classes.slideshowContainer}
      autoplay={
        !(
          transitionTypeValue === 'slide' &&
          slideshowSetting?.transitionDirection?.value === 'ltor'
        )
      }
    >
      {images.map((image, index) => (
        <BackgroundSlideshowImage
          image={image}
          key={index}
        />
      ))}
    </SlideshowWrapper>
  );
};
BackgroundSlideshow.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({})),
  slideshowSetting: PropTypes.shape({
    enableControls: PropTypes.bool,
    slideDuration: PropTypes.number,
    transitionSpeed: PropTypes.number,
    transitionDirection: PropTypes.shape({
      value: PropTypes.string,
    }),
    transitionType: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

BackgroundSlideshow.defaultProps = {
  images: [],
  slideshowSetting: {
    enableControls: false,
    slideDuration: 4,
    transitionSpeed: 400,
    transitionDirection: { value: 'rtol' },
    transitionType: { value: 'fade' },
  },
};

export default BackgroundSlideshow;
